(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var burger = document.getElementById('burger');
  var nav = document.getElementById('nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('on');
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('on');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }


  
  /* ---------- Quantity ---------- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('.qty__i');
    if (!input) return;
    q.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        var next = b.getAttribute('data-q') === '+' ? val + 1 : val - 1;
        input.value = Math.max(min, Math.min(max, next));
      });
    });
  });

  /* ---------- Show more (bullet points) ---------- */
  var moreBtn = document.querySelector('[data-more]');
  var ptsList = document.querySelector('[data-pts]');
  if (moreBtn && ptsList) {
    var label = moreBtn.querySelector('[data-more-tx]');
    var openTx = label ? label.textContent : 'Mehr anzeigen';
    var shutTx = 'Weniger anzeigen';
    moreBtn.addEventListener('click', function () {
      var open = moreBtn.classList.toggle('on');
      ptsList.querySelectorAll('li').forEach(function (li) {
        li.classList.toggle('is-hidden', !open && li.dataset.hid === '1');
      });
      if (open) {
        ptsList.querySelectorAll('li.is-hidden').forEach(function (li) {
          li.dataset.hid = '1';
          li.classList.remove('is-hidden');
        });
      }
      if (label) label.textContent = open ? shutTx : openTx;
      if (!open) {
        var vis = parseInt(ptsList.getAttribute('data-visible'), 10) || 3;
        ptsList.querySelectorAll('li').forEach(function (li, i) {
          li.classList.toggle('is-hidden', i >= vis);
        });
      }
    });
  }

  /* ---------- Feature accordion ---------- */
  document.querySelectorAll('[data-acc]').forEach(function (acc) {
    var items = Array.prototype.slice.call(acc.querySelectorAll('.acc__it'));
    items.forEach(function (it) {
      var q = it.querySelector('.acc__q');
      if (!q) return;
      q.addEventListener('click', function () {
        items.forEach(function (x) { x.classList.remove('on'); });
        it.classList.add('on');
      });
    });
  });

  /* ---------- Sticky cart reveal ---------- */
  var sticky = document.querySelector('[data-sticky]');
  if (sticky) {
    var hero = document.querySelector('.pd');

    if (hero && 'IntersectionObserver' in window) {
      // Product section present: reveal once the buy panel scrolls out of view
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) sticky.classList.remove('on');
          else if (e.boundingClientRect.top < 0) sticky.classList.add('on');
        });
      }, { threshold: 0 }).observe(hero);
    } else {
      // No product section on this page: reveal after a short scroll
      var onScroll = function () {
        sticky.classList.toggle('on', window.scrollY > 300);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Smooth anchors ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

/* ---------- Akkordeon mit Bild ---------- */
(function () {
  document.querySelectorAll('[data-pa]').forEach(function (root) {
    var items = root.querySelectorAll('[data-pa-i]');
    var pics  = root.querySelectorAll('[data-pa-p]');
    items.forEach(function (it) {
      var q = it.querySelector('.pa__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var i = it.getAttribute('data-pa-i');
        items.forEach(function (x) {
          var on = x === it;
          x.classList.toggle('on', on);
          var btn = x.querySelector('.pa__q');
          if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        pics.forEach(function (p) {
          p.classList.toggle('on', p.getAttribute('data-pa-p') === i);
        });
      });
    });
  });
})();

/* ---------- Gallery + Farbe picker ---------- */
(function () {
  var main    = document.querySelector('[data-gal-main]');
  var thumbs  = Array.prototype.slice.call(document.querySelectorAll('.gal__th'));
  var dots    = Array.prototype.slice.call(document.querySelectorAll('.gal__dot'));
  var counter = document.querySelector('[data-gal-i]');
  var total   = document.querySelector('[data-gal-n]');
  var prev    = document.querySelector('[data-gal-prev]');
  var next    = document.querySelector('[data-gal-next]');
  var vbtns   = Array.prototype.slice.call(document.querySelectorAll('.vpick__b'));

  // :not(.vpick__b) — the colour buttons carry data-price/data-compare too
  var priceEls   = document.querySelectorAll('[data-price]:not(.vpick__b), [data-sticky-price]');
  var compareEls = document.querySelectorAll('[data-compare]:not(.vpick__b), [data-sticky-compare]');
  var idInputs   = document.querySelectorAll('[data-variant-input]');

  var colours = vbtns.map(function (b) { return (b.dataset.vname || '').toLowerCase(); });
  var visible = thumbs.slice();
  var cur = 0;

  function show(n) {
    if (!main || !visible.length) return;
    cur = (n + visible.length) % visible.length;           // wrap around
    var t = visible[cur];
    main.src = t.getAttribute('data-src');
    main.alt = t.getAttribute('data-alt') || '';
    thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
    dots.forEach(function (d, i) { d.classList.toggle('on', thumbs[i] === t); });
    if (counter) counter.textContent = cur + 1;
    var box = t.parentNode;                                   // keep active thumb in view
    if (box) box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
  }

  // Images whose alt text contains a colour name show only for that colour.
  // Images with no colour name in the alt text show for every colour.
  // Images are grouped by order: each colour's variant image starts its group,
  // which runs until the next colour's variant image. Images placed before the
  // first variant image are shared and show for every colour. Language-independent.
  function applyColour(name, img) {
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); });
    var anchors = [];
    vbtns.forEach(function (b) {
      var i = srcs.indexOf(b.dataset.img);
      if (i > -1 && anchors.indexOf(i) === -1) anchors.push(i);
    });
    anchors.sort(function (x, y) { return x - y; });

    var start = srcs.indexOf(img);
    // every colour needs its own distinct variant image, otherwise show everything
    if (start === -1 || anchors.length < vbtns.length) {
      visible = thumbs.slice();
    } else {
      var end = thumbs.length;
      anchors.forEach(function (x) { if (x > start && x < end) end = x; });
      visible = thumbs.slice(0, anchors[0]).concat(thumbs.slice(start, end));
    }

    thumbs.forEach(function (t, i) {
      var on = visible.indexOf(t) !== -1;
      t.hidden = !on;
      if (dots[i]) dots[i].hidden = !on;
    });
    if (total) total.textContent = visible.length;
    if (prev) prev.hidden = visible.length < 2;
    if (next) next.hidden = visible.length < 2;

    var first = 0;
    visible.forEach(function (t, i) { if (t.getAttribute('data-src') === img) first = i; });
    show(first);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { var i = visible.indexOf(t); if (i > -1) show(i); });
  });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { var j = visible.indexOf(thumbs[i]); if (j > -1) show(j); });
  });
  if (prev) prev.addEventListener('click', function () { show(cur - 1); });
  if (next) next.addEventListener('click', function () { show(cur + 1); });

  vbtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var fs = b.closest('[data-vpick]');
      if (fs) fs.querySelectorAll('.vpick__b').forEach(function (x) {
        x.classList.remove('on');
        x.setAttribute('aria-pressed', 'false');
      });
      b.classList.add('on');
      b.setAttribute('aria-pressed', 'true');

      var nameEl = fs && fs.querySelector('[data-vpick-name]');
      if (nameEl) nameEl.textContent = b.dataset.vname;
      idInputs.forEach(function (i) { i.value = b.dataset.vid; });
      priceEls.forEach(function (el) { el.textContent = b.dataset.price; });
      compareEls.forEach(function (el) {
        el.textContent = b.dataset.compare;
        el.hidden = !b.dataset.compare;
      });
      applyColour(b.dataset.vname, b.dataset.img);
    });
  });

  var initial = document.querySelector('.vpick__b.on');
  if (initial) applyColour(initial.dataset.vname, initial.dataset.img);
})();
/* ---------- Cart + checkout ---------- */
(function () {
  // ----- CONFIG -----
  var CHECKOUT_URL = "https://checkout.terrivo.shop/api/start";  // xcheckout endpoint, e.g. "https://checkout.example.com/api/start" — empty = Shopify checkout
  var META_PIXEL_ID = "29010368635316954"; // e.g. "1234567890123456" — empty = pixel off

  // ----- META PIXEL BASE CODE -----
  // Lifted verbatim from https://developers.facebook.com/docs/meta-pixel/get-started
  if (META_PIXEL_ID) {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }

  var THEME = window.THEME || {};
  var S = THEME.strings || {};
  var LANG = THEME.lang || document.documentElement.lang || 'de';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  // ----- Meta click ID: the ad lands on the product page, so keep it until checkout -----
  try {
    var fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) sessionStorage.setItem('trv_fbclid', JSON.stringify({ v: fbclid, t: Date.now() }));
  } catch (e) {}

  function storedClick() {
    try { return JSON.parse(sessionStorage.getItem('trv_fbclid') || 'null'); } catch (e) { return null; }
  }
  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(name + '=') === 0) return decodeURIComponent(parts[i].slice(name.length + 1));
    }
    return undefined;
  }

  function postJSON(url, body) {
    return fetch(root + url, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Error');
          return d;
        });
      });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  var toastEl, toastTimer;
  function toast(ok, msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    toastEl.classList.toggle('toast--err', !ok);
    var t = document.createElement('span');
    t.className = 'toast__t';
    t.textContent = msg;
    toastEl.appendChild(t);
    if (ok) {
      var a = document.createElement('a');
      a.className = 'toast__a';
      a.href = root + 'cart';
      a.textContent = S.viewCart || 'Cart';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('on'); }, 4000);
  }

  /* --- Add to cart (product form + sticky bar) --- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var fd = new FormData(form);
      var id = parseInt(fd.get('id'), 10);                 // the colour picker keeps this in sync
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (!id) return;
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

      var added;
      postJSON('cart/add.js', { items: [{ id: id, quantity: qty }] })
        .then(function (d) { added = d.items || []; return getCart(); })
        .then(function (cart) {
          setCount(cart.item_count);
          toast(true, S.added || '✓');
          if (window.fbq && added.length) {
            window.fbq('track', 'AddToCart', {
              value: added.reduce(function (s, i) { return s + i.final_line_price; }, 0) / 100,
              currency: cart.currency,
              content_type: 'product',
              content_ids: added.map(function (i) { return String(i.variant_id); })
            });
          }
        })
        .catch(function (err) { toast(false, err.message || S.errorAdd); })
        .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
    });
  });

  /* --- Cart page: quantity +/-, typed quantity, remove --- */
  var sec = document.querySelector('[data-cart-section]');
  if (sec) {
    var sid = sec.getAttribute('data-cart-section');
    var busy = false;

    var change = function (key, qty) {
      if (busy) return;
      busy = true;
      sec.classList.add('is-busy');
      postJSON('cart/change.js', { id: key, quantity: Math.max(0, qty), sections: sid })
        .then(function (cart) {
          setCount(cart.item_count);
          var html = cart.sections && cart.sections[sid];
          var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
          if (fresh) sec.innerHTML = fresh.innerHTML;
          else window.location.reload();
        })
        .catch(function (err) { toast(false, err.message || S.errorUpdate); })
        .finally(function () { busy = false; sec.classList.remove('is-busy'); });
    };

    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-qty]');
      if (!b) return;
      e.preventDefault();
      var li = b.closest('[data-key]');
      if (li) change(li.getAttribute('data-key'), parseInt(b.getAttribute('data-cart-qty'), 10));
    });
    sec.addEventListener('change', function (e) {
      var i = e.target.closest('[data-cart-input]');
      if (!i) return;
      var li = i.closest('[data-key]');
      if (li) change(li.getAttribute('data-key'), parseInt(i.value, 10) || 0);
    });
    sec.addEventListener('keydown', function (e) {
      // Enter in a qty field would otherwise submit the form = jump to checkout
      if (e.key === 'Enter' && e.target.closest('[data-cart-input]')) { e.preventDefault(); e.target.blur(); }
    });
  }

  /* --- "Zur Kasse" → xcheckout (only once CHECKOUT_URL is set) --- */
  var CHECKOUT_BTN = '[data-cart-section] button[name="checkout"]';

  function buildPayload(c) {
    var click = storedClick();
    return {
      items: c.items.map(function (i) {
        var img = (i.featured_image && i.featured_image.url) || i.image;
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        return {
          variant_id: i.variant_id,
          product_id: i.product_id,
          quantity: i.quantity,
          title: i.product_title,
          variant_title: i.variant_title || undefined,
          price: i.final_price,
          featured_image: img ? { url: img } : undefined
        };
      }),
      currency: c.currency,
      payment_mode: 'one_time',  //one_time
      interval: 'month',
      lang: LANG,
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc') || (click ? 'fb.1.' + click.t + '.' + click.v : undefined),
      fbclid: click ? click.v : undefined          // undefined fields are dropped by JSON.stringify
    };
  }

  function submitToXcheckout(payload) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = CHECKOUT_URL;
    form.style.display = 'none';
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'cart';
    input.value = JSON.stringify(payload);
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  document.addEventListener('click', function (e) {
    if (!CHECKOUT_URL) return;                   // not configured → normal Shopify checkout
    var btn = e.target.closest(CHECKOUT_BTN);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;

    getCart()
      .then(function (c) {
        if (!c.items.length) { window.location.reload(); return; }
        var payload = buildPayload(c);
        submitToXcheckout(payload);
      })
      .catch(function (err) {
        console.error(err);
        btn.disabled = false;
        toast(false, S.errorCheckout);
      });
  });

  // Back button from xcheckout: Safari restores the page with the button still disabled
  window.addEventListener('pageshow', function () {
    document.querySelectorAll(CHECKOUT_BTN).forEach(function (b) { b.disabled = false; });
  });
})();